import { api_GET, api_POST, api_PUT } from "./_api.js";

const colegiadoVotacao_api = {
    getList: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ColegiadoVotacao/GetList`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getListAtivos: () => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ColegiadoVotacao/GetListAtivos`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    getItem: (id) => {
        const promise = new Promise((resolve, reject) => {
            api_GET(`ColegiadoVotacao/getItem/${id}`)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    PostUsuarioVotacao: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ColegiadoVotacao/PostUsuarioVotacao`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    post: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_POST(`ColegiadoVotacao`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    },
    put: (json) => {
        const promise = new Promise((resolve, reject) => {
            api_PUT(`ColegiadoVotacao`, json)
                .then(result => resolve(result))
                .catch(result => reject(result));
        });
        return promise;
    }
}

export default colegiadoVotacao_api;
